import * as React from 'react';

import { BookedOverlay } from 'shared/components/NewbuildingBookedOverlay/BookedOverlay';

import * as styles from './NewbuildingBookedOverlay.css';

export const NewbuildingBookedOverlay = () => {
  return (
    <div className={styles['container']}>
      <BookedOverlay />;
    </div>
  );
};
